import { authenticatedPost } from '../../../../../../api/request';

export default async function createBasicProfile(idDoctorUser, basicProfile, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando su información de perfil.');
    const url = `/doctor-profile-management/create/${idDoctorUser}`;
    return await authenticatedPost(url, onFail, basicProfile);
}
